import { apiClient, ApiResponse } from '@/features/shared/api/apiClient';
import type { RoleDto, CreateRoleDto, UpdateRoleDto } from '../types';

class RoleService {
  async getAllRoles(): Promise<RoleDto[]> {
    const { data } = await apiClient.get<ApiResponse<RoleDto[]>>('/authorization/roles');
    if (data.success && data.data) {
      return data.data;
    }
    throw new Error(data.message || 'Failed to fetch roles');
  }

  async getRoleById(id: number): Promise<RoleDto> {
    const { data } = await apiClient.get<ApiResponse<RoleDto>>(`/authorization/roles/${id}`);
    if (data.success && data.data) {
      return data.data;
    }
    throw new Error(data.message || 'Failed to fetch role');
  }

  async createRole(roleData: CreateRoleDto): Promise<RoleDto> {
    const { data } = await apiClient.post<ApiResponse<RoleDto>>('/authorization/roles', roleData);
    if (data.success && data.data) {
      return data.data;
    }
    throw new Error(data.message || 'Failed to create role');
  }

  async updateRole(id: number, roleData: UpdateRoleDto): Promise<RoleDto> {
    const { data } = await apiClient.put<ApiResponse<RoleDto>>(`/authorization/roles/${id}`, roleData);
    if (data.success && data.data) {
      return data.data;
    }
    throw new Error(data.message || 'Failed to update role');
  }

  async updateRolePermissions(id: number, permissionCodes: string[]): Promise<RoleDto> {
    const { data } = await apiClient.put<ApiResponse<RoleDto>>(
      `/authorization/roles/${id}/permissions`,
      { permissionCodes }
    );
    if (data.success && data.data) {
      return data.data;
    }
    throw new Error(data.message || 'Failed to update role permissions');
  }
}

export const roleService = new RoleService();
